import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from "react-redux";
import { DialogForm, FormText } from "@advosys/component-react";
import { getObjectWithValues, useForm, useValidationRules } from "@advosys/component-react-form";
import { actions } from "../../dynamic-invoice-page-store";
import { useT } from "./reject-dialog-i18n";
const mapStateToProps = (state) => state.dynamicInvoices.dynamicInvoicesPages.dynamicInvoicesPage.page.dialogSubmitting;
const RejectDialogBase = (props) => {
    const { t } = useT();
    const { maxLength, required } = useValidationRules();
    const { preparedInvoice, submitting, submitError, rejectPreparedInvoiceRequest, hideRejectDialog } = props;
    const { formState, formController, validateForm } = useForm({
        submitting,
        validation: {
            validators: {
                rejectReason: () => [required, maxLength(1000)]
            }
        }
    });
    const handleSubmit = () => {
        if (validateForm()) {
            const values = getObjectWithValues(formController, formState);
            rejectPreparedInvoiceRequest(preparedInvoice.id, values);
        }
    };
    return (_jsx(DialogForm, { dialogProps: { size: "small", header: t.dialogHeader, isBlocking: true }, isSubmitting: submitting, submitError: submitError, hasUnsavedChanges: false, onSubmit: handleSubmit, cancel: { onCancel: hideRejectDialog }, submitButtonProps: { text: t.buttonSubmitText }, preventDisableSubmitButtonWhenUnsavedChanges: true, children: _jsx(FormText, { formFieldState: formState.rejectReason, formFieldController: formController.rejectReason, label: t.reason, autoFocus: true, multiline: true }) }));
};
export const RejectDialog = connect(mapStateToProps, actions)(RejectDialogBase);
